module.exports = __webpack_public_path__ + "static/media/stats.74470331.png";